import { User } from 'models/User';
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { IoMicOutline, IoVideocamOffOutline, IoVideocamOutline } from "react-icons/io5";
import { IoMicOffOutline } from "react-icons/io5";
// import { SelfieSegmentation } from "@mediapipe/selfie_segmentation";

interface PeerViewProps {
  style: any,
  streamURL: any,
  mute?: boolean,
  micState?: boolean,
  logicalMute?: boolean,
  peerEmail?: string;
  caller?: string;
  allStream?: any;
  micIcon?: boolean;
  isExpandedView?: boolean,
  userDatax?: any,
  height?: any,
  width?: any
}
const PeerView = ({ height, width, style, streamURL, logicalMute, peerEmail, caller, micIcon, isExpandedView, userDatax }: PeerViewProps) => {
  const [mediaStream, setMediaStream] = useState(streamURL);
  const consumers = useSelector((state: any) => state?.live.settings?.consumers);
  const { sessionSettingData } = useSelector((state: any) => state?.live.settings);
  const settings: any = useSelector((state: RootState) => state.live.settings);
  const [mute, setMute] = useState(micIcon);
  const [userEmail, setUserEmail] = useState('');
  let countReducer = useSelector((state: any) => state.countReducer?.micState);
  const [micState, setMicState] = useState();
  const userData: any = useSelector((state: any) => { state.auth.user as User });
  const videoRef = useRef(null);
  const selfieSegmentationRef = useRef<any | null>(null);
  const constraintsRef = useRef<MediaStreamConstraints | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const canvasCtxRef = useRef<CanvasRenderingContext2D | null>(null);
  const activeEffect = useRef<"mask" | "both" | "none">("mask");
  const { trainer, bgImage } = useSelector((state: RootState) => state.live.settings);
  const bgImageRef = useRef<HTMLImageElement | null>(null);
  const animationFrameId = useRef<number | null>(null);

  useEffect(() => {
    setUserEmail(userData?.email || '');
  }, []);

  useEffect(() => {
    if (peerEmail === userEmail) {
      if (countReducer === 'unsupported') {
        setMute(false);
      }
      if (countReducer === 'on') {
        setMute(true);
      }
    }
  }, [countReducer, peerEmail, userEmail]);

  useEffect(() => {
    if (streamURL && streamURL instanceof MediaStream && videoRef.current) {
      setMediaStream(streamURL);
      videoRef.current.srcObject = streamURL;

      if (bgImage[userEmail] && bgImageRef.current && selfieSegmentationRef.current) {
        const processFrame = async () => {
          if (videoRef.current && selfieSegmentationRef.current) {
            await selfieSegmentationRef.current.send({ image: videoRef.current });
          }
          animationFrameId.current = requestAnimationFrame(processFrame);
        };

        videoRef.current.onloadedmetadata = () => {
          videoRef.current!.play().catch((err) => console.error('Video play error:', err));
          processFrame();
        };
      } else {
        videoRef.current.onloadedmetadata = () => {
          videoRef.current!.play().catch((err) => console.error('Video play error:', err));
        };
      }
    }

    return () => {
      if (animationFrameId.current) {
        cancelAnimationFrame(animationFrameId.current);
      }
    };
  }, [streamURL, bgImage[userEmail]]);


  function muteRemoteAudio(remoteStream) {
    if (remoteStream) {
      if (!(remoteStream instanceof MediaStream)) {
        remoteStream = new MediaStream(remoteStream.tracks);
      } else {
        remoteStream.getAudioTracks().forEach((track) => {
          track.enabled = false;
        });
      }
    }
    return remoteStream;
  }

  useEffect(() => {
    const videoEl = videoRef.current;
    if (!videoEl || !streamURL) return;

    if (streamURL instanceof MediaStream) {
      // Ensure all audio tracks are disabled before attaching
      // streamURL.getAudioTracks().forEach((track) => {
      //   track.enabled = false;
      // });

      setMediaStream(streamURL);
      videoEl.srcObject = streamURL;
    }

    videoEl.muted = true; // always muted — safety net
    // videoEl.onloadedmetadata = () => {
    //   videoEl
    //     .play()
    //     .then(() => console.log(`🎥 Video playing for ${peerEmail}`))
    //     .catch((err) => console.warn("Video play error:", err));
    // };

    return () => {
      if (videoEl) {
        videoEl.pause();
        videoEl.srcObject = null;
      }
    };
  }, [streamURL, peerEmail]);

  const groupBy = (objectArray: any[], property: string) => {
    return objectArray.reduce(function (acc, obj) {
      var key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  // useEffect(() => {
  //   if (peerEmail !== userEmail && consumers) {
  //     const _consumers = Object.values(consumers);
  //     const newConsumerArray = groupBy(_consumers, 'peerId');
  //     const _newConsumerArray = Object.values(newConsumerArray);
  //     _newConsumerArray.forEach((c: any) => {
  //       c.forEach((obj) => {
  //         if (obj?.codec === 'opus' && obj?.peerId === peerEmail) {
  //           setMute(obj?.remotelyPaused === false);
  //         }
  //       });
  //     });
  //   }
  // }, [consumers, micIcon, peerEmail, userEmail]);

  const getTailwindSize = (size: number | string | undefined, isWidth: boolean): string => {
    if (!size) {
      return isWidth
        ? 'w-full'
        : 'h-[55vh] mobile:h-48 tablet:h-[60vh] laptop:h-[65vh] desktop:h-[70vh] largescreen:h-[55vh]';
    }
    if (typeof size === 'string') {
      // Handle vh/vw or Tailwind classes
      if (size.endsWith('vh') || size.endsWith('vw')) {
        return isWidth ? `w-[${size}]` : `h-[${size}]`;
      }
      return size;
    }
    // Map pixel values to Tailwind classes
    const sizeMap: { [key: number]: string } = isWidth
      ? {
        128: 'w-32',
        192: 'w-48',
        256: 'w-64',
        320: 'w-80',
        384: 'w-96',
      }
      : {
        32: 'h-8',
        40: 'h-10',
        48: 'h-12',
        64: 'h-16',
        80: 'h-20',
        96: 'h-24',
        112: 'h-28',
        128: 'h-32',
        144: 'h-36',
        160: 'h-40',
        176: 'h-44',
        192: 'h-48',
        208: 'h-52',
        224: 'h-56',
        240: 'h-60',
        256: 'h-64',
        288: 'h-72',
        320: 'h-80',
        384: 'h-96',
        390: 'h-[50vh]',
        448: 'h-112',
        512: 'h-128',
        576: 'h-144',
        580: 'h-[57vh]',
        640: 'h-160',
        660: 'h-[80vh]'
      };
    if (isWidth) {
      return sizeMap[size] || `w-[${size}px]`;
    }
    // Find closest height class for web view
    const heightKeys = Object.keys(sizeMap).map(Number).sort((a, b) => a - b);
    const closestHeight = heightKeys.reduce((prev, curr) =>
      Math.abs(curr - size) < Math.abs(prev - size) ? curr : prev
    );
    return sizeMap[closestHeight] || `h-[${size}px]`;
  };

  const containerClasses = [
    'relative',
    getTailwindSize(width, true),
    getTailwindSize(height, false), style?.height ?? 'mobile:h-60', 'flex-1  tablet:h-60 laptop:h-[55vh] desktop:h-[55vh] ',
  ].join(' ');

  return (
    <div className={containerClasses}>
      {bgImage[userEmail] && bgImageRef.current ? (
        <>
          <video
            autoPlay
            playsInline
            muted
            ref={videoRef}
            className="hidden"
          />
          <canvas
            ref={canvasRef}
            className={`w-full h-full bg-[rgba(0,0,0,0.667)] ${style?.ObjectFit === 'contain' ? 'object-contain' : 'object-cover'}`}
          />
        </>
      ) : (
        <video
          autoPlay
          playsInline
          muted
          ref={videoRef}
          className={`w-full h-full bg-[rgba(0,0,0,0.667)] ${style?.ObjectFit === 'contain' ? 'object-contain' : 'object-cover'}`}
        />
      )}
      {!isExpandedView ? (
        <div
          className="bg-[rgba(0,0,0,0.667)] flex items-center justify-center h-6 w-6 absolute left-2 bottom-2 z-[999] rounded-sm"
        >
          {mute ? <IoMicOutline /> : <IoMicOffOutline />}
        </div>
      ) : (
        <div
          className="flex items-center w-full bg-[rgba(20,20,21,0.6)] absolute bottom-0 px-2 py-1"
        >
          <span
            className="text-white text-sm mobile:text-xs tablet:text-sm laptop:text-base font-lato flex-1 text-center"
          >
            {peerEmail === 'trainer@vtt'
              ? trainer.fullName
              : `${userDatax?.name || userDatax?.participant_name || ''} ${userDatax?.Lname || ''}`.trim()}
          </span>
          <div
            className="h-6 w-6 absolute right-2 bottom-1 z-[999]"
          >
            {mute ? <IoMicOutline /> : <IoMicOffOutline />}
          </div>
        </div>
      )}
    </div>
  );
};
export default PeerView;